import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postCreateFirestopList = async (
  projectId,
  firestopListAttributes
) => {
  const apiPath = `firestop-documentation/project/${projectId}/create-firestop-list`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: {
      firestopListAttributes,
    },
    isLocalApiRequest: true,
  });

  const response = await axios(signedRequest);

  return response.data;
};
